import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

import { useRoute, useRouter } from 'vue-router';
import Login from '@/components/Login.vue';
import { useStore } from 'vuex';
import EdgeDock from '@/components/EdgeDock/Index.vue';
import commonService from '@/services/common';
import { onMounted, computed } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import zhTw from 'element-plus/dist/locale/zh-tw.mjs';
import socketManager from '@/utils/socketManager';

const EXCHANGE_RATE_CACHE_KEY = 'exchange_rate_cache';
const EXCHANGE_RATE_TTL = 6 * 60 * 60 * 1000;

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { getSiteConfig } = commonService;
const router = useRouter();
const route = useRoute();
const store = useStore();
const locale = computed(() => (store.state.user.language === 'zh-CN' ? zhCn : zhTw));
const readExchangeRateCache = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(EXCHANGE_RATE_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.rate || !parsed?.ts) return null;
    if (Date.now() - parsed.ts > EXCHANGE_RATE_TTL) return null;
    return parsed.rate;
  } catch (err) {
    return null;
  }
};
const writeExchangeRateCache = (rate) => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(EXCHANGE_RATE_CACHE_KEY, JSON.stringify({ rate, ts: Date.now() }));
  } catch (err) {
    // ignore cache write errors
  }
};
const setExchangeRate = (rate) => {
  store.dispatch('user/setExchangeRate', rate);
  writeExchangeRateCache(rate);
};
onMounted(async () => {
  try {
    router.beforeEach((to, from, next) => {
      next();
    });
    await socketManager.connect();
    const commonSubscribe = socketManager.socket.subscribe('common');
    commonSubscribe.on('message', function (data) {
      if (data.type == 'exchange_rate') {
        if (store.state.user.language === 'zh-CN') {
          setExchangeRate(data.cn_rate);
        } else {
          setExchangeRate(data.tw_rate);
        }
      }
    });
  } catch (err) {
    console.log('err', err);
  }
  const cachedRate = readExchangeRateCache();
  if (cachedRate !== null) {
    setExchangeRate(cachedRate);
  }
  const isCategory = route.name === 'Category';
  if (!isCategory || cachedRate === null) {
    getSiteConfig().then((res) => {
      if (res.code == 0) {
        setExchangeRate(res.result.exchange_rate);
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: locale.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(EdgeDock),
        _createVNode(_component_router_view),
        (['/wechat_login', '/line_callback', '/wechat_bind', '/line_bind'].indexOf(_unref(route).path))
          ? (_openBlock(), _createBlock(Login, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})